export const SET_STATE = 'SET_STATE'
export const CLEAR_STATE = 'CLEAR_STATE'
export const START_REQUEST = 'START_REQUEST'
export const END_REQUEST = 'END_REQUEST'
export const SET_PAGINATION = 'SET_PAGINATION'
export const SET_FILTER = 'SET_FILTER'
export const CLEAR_FILTER = 'CLEAR_FILTER'
export const SET_PAGE = 'SET_PAGE'
export const SET_ORDERING = 'SET_ORDERING'
